<template>
  <!--begin::Modal - View Users-->
  <div>
    <div
      class="modal fade"
      id="kt_modal_view_users"
      tabindex="-1"
      aria-hidden="true"
      ref="viewAddressModalRef"
    >
      <!--begin::Modal dialog-->
      <div class="modal-dialog modal-dialog-centered mw-550px">
        <!--begin::Modal content-->
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header justify-content-between">
            <h5 class="modal-title">เลือกที่อยู่เปิดใบกำกับภาษี</h5>
            <!--begin::Close-->
            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>

            <!--end::Close-->
          </div>
          <!--begin::Modal header-->

          <!--begin::Modal body-->
          <div class="modal-body">
            <loading
              v-model:active="isLoading"
              :can-cancel="true"
              :is-full-page="false"
            />
            <div
              class="fs-1 fw-bold text-gray-400 text-center py-10"
              v-if="!addresses.length"
            >
              <div v-if="isLoading">
                <span class="sr-only">Loading...</span>
              </div>
              <div v-else>ไม่มีข้อมูลที่อยู่เปิดใบกำกับ</div>
            </div>
            <div class="list-group list-group-flush list-group-item-action">
              <div
                v-for="(address, index) in addresses"
                :key="index"
                class="list-group-item list-group-item-action"
                :class="{
                  'bg-light':
                    selectedAddress &&
                    selectedAddress.custAddrID == address.custAddrID,
                }"
                @click="() => onSelect(address)"
                style="cursor: pointer"
              >
                <div class="row mx-5 my-3">
                  <div class="col-6">
                    <p
                      class="
                        d-flex
                        align-items-center
                        fs-4
                        fw-bolder
                        text-dark text-hover-primary
                      "
                    >
                      {{ address.custAddrName }}
                    </p>
                    <div class="fs-5 text-gray-600">
                      {{ address.custAddrShow }}
                    </div>
                    <!-- <div class="fw-bold text-gray-400">
                    {{ address.custAddrTaxID }}  {{address.custAddrTaxBranch}}
                  </div> -->
                  </div>
                  <div class="col-6">
                    <p class="fs-5 fw-bolder text-dark text-end">
                      {{ address.custAddrTaxID }}
                    </p>
                    <div class="fs-5 text-dark text-end text-gray-600">
                      {{ address.custAddrTaxBranch }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end::Modal body-->
          <div class="modal-footer justify-content-between">
            <div>
              <button class="btn btn-light-primary" @click="openCreateAddress">
                สร้าง
              </button>
            </div>
            <div>
              <button
                type="button"
                class="btn btn-light"
                data-bs-dismiss="modal"
              >
                ปิด
              </button>
              <!-- <button
                type="button"
                class="btn btn-primary ms-5"
                @click="onSelect"
              >
                ตกลง
              </button> -->
            </div>
          </div>
        </div>
        <!--end::Modal content-->
      </div>
      <!--end::Modal dialog-->
    </div>
    <!--end::Modal - View Users-->
    <add-cust-addr-modal
      @refreshdata="getAddresses"
      ref="refCreateAddressModal"
    ></add-cust-addr-modal>
  </div>
</template>

<script>
import { Modal } from "bootstrap";
import ApiService from "@/core/services/ApiService";
import AddCustAddrModal from "@/components/modals/forms/AddCustAddrModal";
import Loading from "vue-loading-overlay";

export default {
  components: { AddCustAddrModal, Loading },
  props: {
    customerId: Number,
  },
  data() {
    return {
      addresses: [],
      addressModal: null,
      searchText: null,
      selectedAddress: null,
      isLoading: false,
    };
  },
  mounted() {
    this.addressModal = new Modal(this.$refs.viewAddressModalRef);
  },
  methods: {
    show() {
      this.addressModal.show();
      this.selectedAddress = null;
      this.getAddresses();
    },
    hide() {
      this.addressModal.hide();
      this.selectedAddress = null;
    },
    openCreateAddress() {
      this.$refs["refCreateAddressModal"].show('C',this.customerId);
    },
    getAddresses() {
      this.isLoading = true;
      ApiService.query("customers/GetCustAddr?ContactID=" + this.customerId)
        .then(({ data }) => {
          this.addresses = data;
        })
        .catch((err) => console.log(err.response))
        .finally(() => (this.isLoading = false));
    },
    onSelect(address) {
      this.$emit("select", address);
      this.hide();
    },
  },
};
</script>
